import React from "react";

const UserDashboard = () => {
  return <div className="">UserDashboard</div>;
};

export default UserDashboard;
